<template>
  <div class="userindex">
    <div  class="van-content">
      <div :style="{backgroundImage: 'url(' + toppPic + ')' }"  style="background-repeat:no-repeat;background-size:100% 100% " class="userbanner" >
      </div>
      <van-cell-group >
        <router-link to="" class="van-cell van-hairline">
          <div class="van-cell__title">
            <span style="font-size: 16px">{{datas.name}}</span>
            <p>{{datas.points}}</p>
          </div>
        </router-link>
      </van-cell-group>
      <van-cell-group style="margin-top: 8px;padding: 10px 15px" >
        <p v-html="datas.content"></p>
      </van-cell-group>




    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    props:['configData'],
    data () {
      return {
        datas:'',
        toppPic:'',
        id1:this.$route.query.id,
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Discount/preview', {token:isUser,id:this.id1}, res => {
          this.datas = res.data.data
          this.toppPic=res.data.data.banner_img
        })
      },

    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
  .userindex{
  .van-card__title{
    font-size: 16px;
  }
  .van-card__row describe{
    font-size: 14px;
  }
  .van-content{
    padding-top: 0;
  }
  .userbanner{
    height: 190px;
    position: relative;
  .userbox{
    padding-top: 45px;
    text-align: center;
  .vipname{
    background: #fb4141;
    padding: 4px 6px;
    border-radius: 6px;
    margin-right: 7px;
  }
  .name{
    font-size: 2rem;
  }
  .vipjif{
    margin-top: 5px;
    font-size: 1.6rem;
    color: #fff;
  }
  img{
    width: 70px;
    height: 70px;
    vertical-align: top;
    margin-right: 5px;
    border-radius: 50%;
  }
  .userInfo{
    display: inline-block;
    padding-top: 9px;
  p{
    color: #fff;
  }
  }
  .userInfo.will{
    padding-top: 0px;
    display: inline-block;
  p{
    color: #fff;
  }
  }
  }
  .signintag{
    background: #fa2924;
    width: 60px;
    display: inline-block;
    position: absolute;
    z-index: 1;
    right: 0;
    margin-top: 40px;
    overflow: hidden;
    border-radius: 16px 0 0 16px;
    box-shadow: 0px 1px 6px -1px #333;
  }

  }
  .van-cell:not(:last-child)::after{
    left: 0;
  }
  .userOrder{
    position: relative;
  }
  .van-cell-group,.van-cell{
    background: #fff;
  }
  .ordercell{
  img{
    width: 25px;
    height: auto;
    margin-bottom: 5px;
  }
  }
  .van-cell-group{
  .van-cell__title{
  img{
    width: 30px;
    margin-right: 5px;
  }
  }
  }

  .van-col--6 {
    text-align: center;
    height: 25vw;
    padding: 4%;
    background-color: #fff;
    border-right: 1px solid #EEEEEE;
    position: relative;
  p{
    text-align: center!important;
    width: 70px;
    position: absolute;
    left: 50%;
    margin-left: -35px;
  }
  }


  .van-cell-group {
    margin-bottom: 0px;
    border-bottom: 1px solid #EEEEEE;
  }
  .describe{
    height: 40px;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:2;
    overflow: hidden;
  }

  }
</style>



// WEBPACK FOOTER //
// src/pages/user/do/detail.vue